<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="220px">
            <el-form-item label="分部编号：" prop="branch_code">
                <span>{{model.branch_code}}</span>
            </el-form-item>
            <el-form-item label="分部名称：" prop="branch_name">
                <span>{{model.branch_name}}</span>
            </el-form-item>
            <el-form-item label="单元编号：" prop="unit_code">
                <span>{{model.unit_code}}</span>
            </el-form-item>
            <el-form-item label="单元名称：" prop="unit_name">
                <span>{{model.unit_name}}</span>
            </el-form-item>
            <el-form-item label="排号：" prop="base_name">
                <span>{{model.base_name}}</span>
            </el-form-item>
            <el-form-item label="基础编号：" prop="base_index">
                <span>{{model.base_index}}</span>
            </el-form-item>
            <el-form-item label="基准起点坐标：" prop="datum_point1">
                <span>{{model.datum_point1}}</span>
            </el-form-item>
            <el-form-item label="基准终点坐标：" prop="datum_point2">
                <span>{{model.datum_point2}}</span>
            </el-form-item>
            <el-form-item label="第一个点距离基准起点的距离：" prop="b_offset">
                <span>{{model.b_offset}}</span>(单位:mm)
            </el-form-item>
            <el-form-item label="最后一个点距离基准终点的距离：" prop="e_offset">
                <span>{{model.e_offset}}</span>(单位:mm)
            </el-form-item>
            <!-- <el-form-item label="孔距：" prop="pitch">
                <span>{{model.pitch}}</span>
            </el-form-item> -->
            <el-form-item label="垂直偏移量：" prop="distance_y">
                <span>{{model.distance_y}}</span>
            </el-form-item>
            <el-form-item label="灌浆类型：" prop="grout_type">
                <span>{{ transEnu(model.grout_type, "grout_type") }}</span>
            </el-form-item>
            <el-form-item label="孔直径：" prop="diameter">
                <span>{{model.diameter}}</span>
            </el-form-item>
            <el-form-item label="孔数：" prop="diameter">
                <span>{{model.hole_count}}</span>
            </el-form-item>
            <el-form-item label="循序：" prop="sequential">
                <span>{{ transEnu(model.sequential, "sequential") }}</span>
            </el-form-item>
            <el-form-item label="添加人名称：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新人名称：" prop="update_name">
                <span>{{model.update_name}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'arrangeInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                pid2: '',
                pid3: '',
                branch_code: '',
                branch_name: '',
                unit_id: '',
                unit_code: '',
                unit_name: '',
                base_name: '',
                base_index: '',
                datum_point1: '',
                datum_point2: '',
                b_offset: '',
                e_offset: '',
                pitch: '',
                distance_y: '',
                grout_type: '',
                diameter: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/arrange/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['grout_type', 'hole_up_index', 'sequential'],
        };
    },
    methods: {}
};
</script>